import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import {useSelector} from "react-redux"


const DashboardLayout = () => {

  const {isLoggedIn} = useSelector((state)=>state.auth)
  
  if(!isLoggedIn){
    return <Navigate to="/auth/login"/>;
  }

  
  return (
    <>
      <Outlet />
    </>
  );
};

export default DashboardLayout;
